import styled from 'styled-components';

import { getThemeValue, colour, Box } from '@leagueplatform/ui-kit';

export const InfoCard = styled(Box)`
  border-radius: ${getThemeValue('radii.3')}px;
  border: 2px solid ${colour('greyLighter')};
  background-color: ${colour('white')};
`;
